import { tv } from "../../../variants/tv.js";
const itineraryButtonVariants = tv({
    slots: {
        root: 'relative isolate flex w-full items-center justify-between gap-2 rounded-full',
        clickableSlot: 'm-0 flex min-w-0 flex-1 cursor-pointer items-center gap-2 overflow-hidden border-none bg-transparent px-3 py-2',
        contentSlot: 'relative z-[3] flex min-w-0 flex-1 flex-col items-center gap-0.5',
        titleSlot: 'flex w-full shrink-0 items-center gap-1',
        titleTextSlot: 'text-body2 font-bold text-primary-13',
        metaDataSlot: 'flex w-full items-center gap-1 overflow-clip text-body3 font-medium text-primary-13',
        data1Slot: '',
        data1SuffixSlot: '',
        data2Slot: '',
        dotSeparatorSlot: 'shrink-0',
        iconSlot: 'relative z-[3] size-6 shrink-0 text-primary-8',
        iconBalanceSlot: 'size-6 shrink-0 opacity-0',
        buttonRightSlot: 'relative z-[3] flex shrink-0 items-center pr-3',
        backgroundSlot: 'absolute inset-0 z-[1] flex h-full min-h-px w-full min-w-px flex-1 items-center justify-center gap-3 rounded-full',
        backgroundBlurSlot: 'h-full min-h-px min-w-px flex-1 rounded-full bg-neutral-1/[0.01] backdrop-blur-lg'
    },
    variants: {
        align: {
            left: {
                titleSlot: 'justify-start',
                metaDataSlot: 'justify-start',
                iconBalanceSlot: 'hidden'
            },
            center: {
                titleSlot: 'justify-center text-center',
                metaDataSlot: 'justify-center'
            }
        },
        condensed: {
            true: {
                root: 'min-h-10',
                contentSlot: 'flex-row gap-1 overflow-clip',
                titleTextSlot: 'text-body3',
                titleSlot: 'w-auto min-w-16 flex-1'
            },
            false: {
                root: 'min-h-[54px]',
                contentSlot: 'flex-col gap-0.5'
            }
        },
        as: {
            div: {
                root: 'min-h-10',
                clickableSlot: 'hidden',
                backgroundSlot: 'bg-transparent shadow-none backdrop-blur-none',
                backgroundBlurSlot: 'bg-transparent backdrop-blur-none'
            },
            button: {
                root: 'hover:bg-primary-3 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-primary-7',
                backgroundSlot: 'bg-glassRadial shadow-[0px_0px_2px_0px_rgba(0,104,239,0.48),0px_2px_4px_0px_rgba(0,104,239,0.25),0px_2px_12px_0px_rgba(0,104,239,0.12),0px_0px_16px_0px_rgba(0,104,239,0.12)]'
            }
        },
        emphasis: {
            regular: {},
            medium: {
                titleTextSlot: 'text-primary-1',
                root: 'hover:ring-1 hover:ring-primary-7/20',
                backgroundSlot: 'bg-primary-11 shadow-none backdrop-blur-none',
                backgroundBlurSlot: 'backdrop-blur-none',
                metaDataSlot: 'text-primary-1',
                iconSlot: 'text-primary-1'
            },
            bold: {
                titleTextSlot: 'text-primary-1',
                root: 'hover:bg-primary-13/20',
                backgroundSlot: 'bg-glass-bold shadow-md',
                metaDataSlot: 'text-primary-1',
                iconSlot: 'text-primary-1'
            }
        },
        animate: {
            true: '',
            false: ''
        },
        hasIcon: {
            true: '',
            false: {
                iconSlot: 'hidden',
                iconBalanceSlot: 'hidden'
            }
        },
        hasButtonRight: {
            true: '',
            false: {
                buttonRightSlot: 'hidden'
            }
        },
        titleTruncate: {
            true: {
                titleTextSlot: 'truncate'
            },
            false: {
                titleTextSlot: 'whitespace-nowrap'
            }
        },
        data1Truncate: {
            true: {
                data1Slot: 'min-w-8 shrink truncate'
            },
            false: {
                data1Slot: 'w-fit shrink-0 whitespace-nowrap'
            }
        },
        data1SuffixTruncate: {
            true: {
                data1SuffixSlot: 'min-w-8 shrink truncate'
            },
            false: {
                data1SuffixSlot: 'w-fit shrink-0 whitespace-nowrap'
            }
        },
        data2Truncate: {
            true: {
                data2Slot: 'min-w-8 shrink truncate'
            },
            false: {
                data2Slot: 'w-fit shrink-0 whitespace-nowrap'
            }
        }
    },
    compoundVariants: [
        {
            as: 'div',
            emphasis: 'medium',
            class: {
                root: 'hover:ring-0',
                backgroundSlot: 'bg-transparent shadow-none backdrop-blur-none',
                backgroundBlurSlot: 'bg-transparent backdrop-blur-none'
            }
        },
        {
            as: 'div',
            emphasis: 'bold',
            class: {
                root: 'hover:bg-transparent',
                backgroundSlot: 'bg-transparent shadow-none backdrop-blur-none',
                backgroundBlurSlot: 'bg-transparent backdrop-blur-none'
            }
        }
    ],
    defaultVariants: {
        align: 'left',
        condensed: false,
        emphasis: 'medium',
        as: 'button',
        animate: false,
        hasIcon: true,
        hasButtonRight: false,
        titleTruncate: true,
        data1Truncate: false,
        data1SuffixTruncate: false,
        data2Truncate: true
    }
});
const itineraryButtonVariantKeys = Object.keys(itineraryButtonVariants.variants);
export { itineraryButtonVariantKeys, itineraryButtonVariants };
